module.exports = __webpack_public_path__ + "media/images/jobinventory-logo-0cca8b15f361a30fd4007cd9172629f0.jpg";